import g, { useState as h, useCallback as Y } from "react";
import { useTheme as Z } from "@chakra-ui/react";
import { Icon as $ } from "../icon/icon.js";
import "@loadable/component";
import { MdFavorite as A, MdFavoriteBorder as oo } from "react-icons/md";
import { getFocusIndicator as to } from "../../../utils/accessibilityUtils.js";
import { getFormattedBorderString as i } from "../../../utils/commonUtils.js";
import { Button as ro } from "./button.js";
import "./icon-button.js";
import "react-icons/fa";
import "./masthead-button.js";
import "framer-motion";
import "react-icons/fi";
import "react-icons/hi";
import "react-icons/ri";
import "react-icons/io5";
import "./close-button.js";
const Mo = ({
  isFavourite: o,
  label: t,
  size: l,
  favouriteClickAction: d,
  ...f
}) => {
  const {
    atl: {
      default: c,
      hover: S,
      pressed: y,
      added: B,
      onDefault: s,
      onPressed: r,
      onHover: b,
      onAdded: p
    },
    buttonSmallIcon: M,
    buttonMediumIcon: x,
    buttonLargeIcon: v,
    buttonSmallHeight: H,
    buttonSmallVertical: I,
    buttonSmallHorizontal: _,
    buttonMediumHeight: k,
    buttonMediumVertical: L,
    buttonMediumHorizontal: R,
    buttonLargeHeight: C,
    buttonLargeVertical: w,
    buttonLargeHorizontal: z,
    buttonFaveBorderRadius: T,
    buttonBorderWidth: e,
    buttonSmallText: V,
    buttonMediumText: D,
    buttonLargeText: E,
    buttonSmallInterior: F,
    buttonMediumInterior: P,
    buttonLargeInterior: U
  } = Z(), [W, u] = h(!1), [n, a] = h(!1), j = {
    small: {
      boxSize: M,
      marginRight: t && F
    },
    medium: {
      boxSize: x,
      marginRight: t && P
    },
    large: {
      boxSize: v,
      marginRight: t && U
    }
  }, q = i({
    width: e,
    color: s,
    style: "solid"
  }), G = i({
    width: e,
    color: b,
    style: "solid"
  }), J = i({
    width: e,
    color: r,
    style: "solid"
  }), K = i({
    width: e,
    color: r,
    style: "solid"
  }), N = {
    small: {
      height: H,
      px: _,
      py: I
    },
    medium: {
      height: k,
      px: R,
      py: L
    },
    large: {
      height: C,
      px: z,
      py: w
    }
  }, O = {
    small: V,
    medium: D,
    large: E
  }, Q = Y(
    (m, X) => {
      m.preventDefault(), a(!n), d && d(!X);
    },
    [n, d]
  );
  return /* @__PURE__ */ g.createElement(
    ro,
    {
      sx: {
        ".chakra-button__icon": {
          marginRight: "0"
        }
      },
      variant: "transparent",
      "data-testid": "favourite-button",
      _hover: { color: b, backgroundColor: S, border: G },
      _focus: { color: r, backgroundColor: B, border: K },
      _pressed: {
        color: r,
        backgroundColor: y,
        border: J
      },
      "aria-pressed": n,
      color: o ? p : s,
      borderRadius: T,
      border: q,
      backgroundColor: c,
      onClick: (m) => Q(m, o),
      _focusVisible: to(c),
      onMouseEnter: () => u(!0),
      onMouseLeave: () => {
        u(!1), a(!1);
      },
      onMouseDown: () => a(!0),
      onMouseUp: () => a(!1),
      onBlur: () => u(!1),
      ...N[l],
      ...O[l],
      ...f
    },
    /* @__PURE__ */ g.createElement(
      $,
      {
        as: o || W || n ? A : oo,
        fill: o ? p : s,
        "aria-hidden": "true",
        ...j[l]
      }
    ),
    t
  );
};
export {
  Mo as FavouriteButton
};
